import { useReducer } from "react";

const initialHistory = {
  past: [],
  present: undefined,
  future: [],
};

const historyReducer = (state, action) => {
  switch (action.type) {
    case "RESET": {
      const newState = action.payload;
      return { past: [], present: newState, future: [] };
    }
    case "UPDATE": {
      const newState = action.payload;
      if (action.source === "user") {
        return {
          past: [...state.past, state.present],
          present: newState,
          future: [],
        };
      }
      return { ...state, present: newState };
    }
    case "UNDO": {
      if (state.past.length === 0) return state;
      const previous = state.past[state.past.length - 1];
      const newPast = state.past.slice(0, -1);
      return {
        past: newPast,
        present: previous,
        future: [state.present, ...state.future],
      };
    }
    case "REDO": {
      if (state.future.length === 0) return state;
      const next = state.future[0];
      const newFuture = state.future.slice(1);
      return {
        past: [...state.past, state.present],
        present: next,
        future: newFuture,
      };
    }
    case "UNDO_ALL": {
      if (state.past.length === 0) return state;
      const firstPast = state.past[0];
      return {
        past: [],
        present: firstPast,
        future: [...state.past.slice(1), state.present, ...state.future],
      };
    }
    case "REDO_ALL": {
      if (state.future.length === 0) return state;
      const finalPresent = state.future[state.future.length - 1];
      return {
        past: [...state.past, state.present, ...state.future.slice(0, -1)],
        present: finalPresent,
        future: [],
      };
    }
    default:
      return state;
  }
};

export const useHistory = (initialState) => {
  const [state, dispatch] = useReducer(historyReducer, {
    ...initialHistory,
    present: initialState,
  });

  const reset = (newState) => dispatch({ type: "RESET", payload: newState });
  const update = (newState, source = "user") =>
    dispatch({ type: "UPDATE", payload: newState, source });
  const undo = () => dispatch({ type: "UNDO" });
  const redo = () => dispatch({ type: "REDO" });
  const undoAll = () => dispatch({ type: "UNDO_ALL" });
  const redoAll = () => dispatch({ type: "REDO_ALL" });

  const canUndo = state.past.length > 0;
  const canRedo = state.future.length > 0;

  return {
    state: state.present,
    reset,
    update,
    undo,
    redo,
    canUndo,
    canRedo,
    past: state.past,
    future: state.future,
    undoAll,
    redoAll,
  };
};
